/**
 * 修改favicon图标通用方法
 * @param link 新图标链接
 */
export const changeFavicon = (link: string) => {
    let faviconEle: HTMLLinkElement | null = document.querySelector('link[rel="icon"]');
    // If a <link rel="icon"> element already exists,
    // change its href to the given link.
    if (faviconEle !== null) {
        faviconEle.href = link;
        // Otherwise, create a new element and append it to <head>.
    } else {
        faviconEle = document.createElement('link');
        faviconEle.rel = 'icon';
        faviconEle.href = link;
        document.head.appendChild(faviconEle);
    }
    let iconEle: HTMLLinkElement | null = document.querySelector('link[rel="shortcut icon"]');
    if (iconEle !== null) {
        iconEle.href = link;
        // Otherwise, create a new element and append it to <head>.
    } else {
        iconEle = document.createElement('link');
        iconEle.rel = 'shortcut icon';
        iconEle.href = link;
        document.head.appendChild(iconEle);
    }
};
